/* import __COLOCATED_TEMPLATE__ from './ask-button.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

/**
 * Shared "Ask" button used to open the Internal Agent sidebar.
 * Ember equivalent of the React AskButton in teammate-app.
 * Uses fin icon + "Ask" label with secondary styling.
 */

import templateOnlyComponent from '@ember/component/template-only';

interface AskButtonSignature {
  Element: HTMLElement;
  Args: {
    onClick: () => void;
  };
}

const AskButton = templateOnlyComponent<AskButtonSignature>();
export default AskButton;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'InternalAgent::AskButton': typeof AskButton;
  }
}
